<template>
  <div
    class="card"
    v-if="question"
    v-loading="loadingchanges"
    element-loading-text="Cargando..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.6)"
  >
    <div class="card-body">
      <form @submit.prevent="storeQuestionDetails">
        <div class="row">
          <div class="col-lg-9">
            <label>Pregunta</label>
            <input
              type="text"
              v-model="question.title"
              class="form-control"
              placeholder="Pregunta"
            />
          </div>

          <div class="col-lg-3">
            <label>Puntos</label>
            <input
              type="number"
              v-model="question.points"
              class="form-control"
              placeholder="Puntos"
              step="any"
              v-on:keypress="validateNumber($event)"
            />
          </div>

          <div class="col-lg-12">
            <div class="form-group">
              <label>Tipo de pregunta</label>
              <el-select
                v-model="questionType"
                placeholder="Seleccione un tipo de pregunta"
                class="d-inline"
                @change="handleChangeSelect"
              >
                <el-option
                  v-for="et in mutableQuestionTypes"
                  :key="et.id"
                  :label="et.name"
                  :value="et.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div v-if="!binaryOption">
            <div>
              <label for="">Opciones</label>
              <div class="input-group mb-3">
                <input type="text" name="option" class="form-control" v-model="option" placeholder="Ingresar opción">
                <button type="button" class="btn btn-primary" @click="addOption()">Guardar opción</button>
              </div>
            </div>
            <div class="row py-2">
              <div class="col-12 col-md-6">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" v-model="isAnswer">
                  <label class="form-check-label" for="">
                    Marcar como respuesta
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div>
              <label for="">Verdadero</label>
              <input class="form-control" type="text" v-model="trueOption" placeholder="Opción verdadera">
            </div>
            <div>
              <label for="">Falso</label>
              <input class="form-control" type="text" v-model="falseOption" placeholder="Opción falsa">
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-center py-2">
          <button type="submit" class="btn btn-success" :disabled="isSubmittingChanges">
            Guardar cambios
          </button>
        </div>
      </form>
      <div class="py-2">
        <div class="table-responsive">
          <table class="table">
            <tbody>
              <tr v-for="(option, index) in options" :key="index">
                <td :class="{'text-success': option.answer}">{{ option.option }}</td>
                <td>
                  <button type="button" class="btn btn-danger text-white" @click="deleteDialog(index)">X</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <el-dialog
      v-model="showDeleteDialog"
      title="Eliminar"
      width="30%"
    >
      <span>¿Eliminar opción?</span>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="showDeleteDialog = false">Cancel</el-button>
          <el-button type="primary" @click="deleteOption()">
            Confirm
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { split } from 'lodash';

export default {
  props: {
    exam: {
      type: Object,
      required: true,
    },
    question: {
      type: Object,
      required: true,
    },
    question_types: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isSubmittingChanges: false,
      checkList: [],
      questionType: this.question.question_type_id,
      max: 1,
      show: null,
      showAll: null,
      mutableQuestionTypes: null,
      loadingchanges: false,
      mutableQuestion: {},
      option: "",
      options: [],
      isAnswer: false,
      isMultipleOption: false,
      binaryOption: false,
      trueOption: "",
      falseOption: "",
      optionSelected: null,
      showDeleteDialog: false,
    };
  },

  created() {
    this.listQuestionTypes();
    this.listQuestion(this.question.question_type_id);
  },

  methods: {
    deleteDialog(index){
      this.optionSelected = index
      this.showDeleteDialog = true
    },
    deleteOption(){
      this.options.splice(this.optionSelected, 1)
      this.showDeleteDialog = false
      this.optionSelected = null
    },
    addOption(){
      if(this.isAnswer){
        var countAnswers = 0;
        this.options.forEach(element => {
          if(element.answer){
            countAnswers++
          }
        });
        countAnswers++
        if(!this.isMultipleOption && countAnswers > 1){
          this.$message.warning('Solo se permite una respuesta en este tipo de examen');
          countAnswers--
        }else{
          var aux = {
            "option": this.option,
            "answer": this.isAnswer
          }
          this.options.push(aux)
          this.option = ""
          this.isAnswer = false
        }
      }else{
        var aux = {
          "option": this.option,
          "answer": this.isAnswer
        }
        this.options.push(aux)
        this.option = ""
        this.isAnswer = false
      }
    },
    listQuestionTypes() {
      if (this.exam.time != 59999940) {
        this.question_types.pop();
        this.mutableQuestionTypes = this.question_types;
      } else {
        //solucion temporal de error pregunta abierta
        this.question_types.pop();
        this.mutableQuestionTypes = this.question_types;
      }
    },
    handleChangeSelect(option) {
      this.options = [];
      switch (option) {
        case 1:
          this.isMultipleOption = false
          this.binaryOption = false
          break;
        case 2:
          this.isMultipleOption = true
          this.binaryOption = false
          break;
        case 3:
          this.isMultipleOption = false
          this.binaryOption = true
          break;
        default:
          break;
      }
    },
    listQuestion(type) {
      axios
        .get(`/productos/exam/question/${this.question.id}/get`)
        .then((response) => {
          this.handleChangeSelect(type);
          if (response.data.error) {
            this.message = 'Sin preguntas registradas';
          } else {
            let options = JSON.parse(response.data.options);
            let correct = response.data.correct.split(",");
            if(type == 3){
              this.trueOption = options[0];
              this.falseOption = options[1];
            }else{
              var aux;
              options.forEach((element, index) => {
                if(correct.includes(index.toString())){
                  aux = {
                    "option": element,
                    "answer": true
                  }
                }else{
                  aux = {
                    "option": element,
                    "answer": false
                  }
                }
                this.options.push(aux);
              });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    handleChangeCheckbox(value) {
      // console.log(value);
    },
    areOnlyNumbers(text) {
      const regex = new RegExp('^[0-9]+([,.][0-9]+)?$');
      return regex.test(text);
    },

    validateFields() {
      if (
        !this.question.title ||
        this.question.title.trim() === '' ||
        this.question.title.length === 0
      ) {
        this.$message.warning('Título esta vacio!');
        return false;
      }
    //   if (this.question.title.length > 255) {
    //     this.$message.warning('Título demasiado largo!');
    //     return false;
    //   }

      if (Number(this.question.points) >= 999) {
        this.$message.warning('Solo se permite números de 3 dígitos para el campo de puntos');
        return false;
      }

      if ( !this.areOnlyNumbers( this.question.points ) ) {
        this.$message.warning('Solo se permite números para el campo de puntos');
        return false;
      }
      var count = 0;
      this.options.forEach( element => {
        if(element.answer){
          count++
        }
      })
      if(count == 0){
        this.$message.warning('Debe seleccionar una respuesta');
        return false
      }
      return true;
    },

    validateResponse( input ){
      if (
        !input ||
        input.trim() === '' ||
        input.length === 0
      ) {
        this.$message.warning('El campo marcado como respuesta correcta está vacío!');
        return true;
      }
      return false;
    },

    restrictChars: function ($event) {
      if ($event.charCode === 0 || /\d/.test(String.fromCharCode($event.charCode))) {
        return true;
      } else {
        $event.preventDefault();
      }
    },

    async storeQuestionDetails() {
      if(this.binaryOption){
        var aux1 = {
          "option": this.trueOption,
          "answer": true
        };
        var aux2 = {
          "option": this.falseOption,
          "answer": false
        }
        this.options.push(aux1, aux2);
      }
      if (this.validateFields()) {
        this.isSubmitting = true;
        const formdata = new FormData();
        formdata.append('exam_question_id', this.question.id);
        formdata.append('title', this.question.title);
        formdata.append('points', this.question.points);
        formdata.append('exam_type', this.questionType);
        formdata.append('options', JSON.stringify(this.options));

        let ruta = '';
        // Validar que id tiene disponible
        if (this.exam.course_id != null) {
          formdata.append('exam_for', 'course');
          ruta = `/productos/exam/edit/${this.exam.id}`;
        } else if (this.exam.module_id != null) {
          formdata.append('exam_for', 'module');
          ruta = `/productos/exam/module/edit/${this.exam.id}`;
        } else if (this.exam.lesson_id != null) {
          formdata.append('exam_for', 'lesson');
          ruta = `/productos/exam/lesson/edit/${this.exam.id}`;
        }
        try {
          this.loading = true;
          const request = await axios({
            url: '/productos/exam/question/options/store',
            method: 'post',
            data: formdata,
          });
          const response =
            request.status == 200
              ? this.$message.success('La pregunta se ha registrado correctamente')
              : await this.$message.warning('Error al validar datos');
          this.isSubmitting = false;
          this.loading = false;
          document.location.href = ruta;
        } catch (error) {
          this.isSubmitting = false;
          this.loading = false;
          console.log(error);
        }
      }
    },
    validateNumber(e){
      let decNum = ['0','1','2','3','4','5','6','7','8','9','.',','];
      if( !decNum.includes(e.key) ){
        e.preventDefault();
        this.$message.warning('Solo se permite números para el campo de puntos');
      }
    },
  },
};
</script>
<style>
.el-checkbox__label {
  font-size: 0;
}
</style>
